module.exports = __webpack_public_path__ + "img/wechat.1a67794c.svg";